'use client';

import { tv } from '../_lib/utils';
import { Container } from '../Container';

const styles = tv({
	slots: {
		base: 'w-full text-border-primary',
	},
	variants: {
		padding: {
			8: {
				base: 'py-2',
			},
			32: {
				base: 'py-8',
			},
			64: {
				base: 'py-16',
			},
			80: {
				base: 'py-20',
			},
		},
	},
});

export type DividerProps = {
	className?: string;
	title?: string;
	padding?: keyof typeof styles.variants.padding;
};

export function Divider(props: DividerProps) {
	const padding = props.padding ?? 8;
	const { base } = styles({ padding });

	return (
		<Container className={base({ className: props.className })}>
			<hr title={props.title} />
		</Container>
	);
}
